import { render, staticRenderFns } from "./healthAi.vue?vue&type=template&id=af445de8&scoped=true"
import script from "./healthAi.vue?vue&type=script&lang=js"
export * from "./healthAi.vue?vue&type=script&lang=js"
import style0 from "./healthAi.vue?vue&type=style&index=0&id=af445de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af445de8",
  null
  
)

export default component.exports